import { render } from "./h5toothmap.vue?vue&type=template&id=28a6d0ef&scoped=true"
import script from "./h5toothmap.vue?vue&type=script&lang=js"
export * from "./h5toothmap.vue?vue&type=script&lang=js"

import "./h5toothmap.vue?vue&type=style&index=0&id=28a6d0ef&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a6d0ef"]])

export default __exports__